import { type AbstractControl, type ValidatorFn, type ValidationErrors } from '@angular/forms';

export function undeliverableValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value === 'UNDELIVERABLE EMAIL' ? { undeliverable: true } : null;
  };
}
